module.exports = __webpack_public_path__ + "img/successful.023b6cef.gif";